export default __webpack_public_path__ + "static/GT-Super-Display-Medium-b0c15c16f1132fcf1052970188a165fb.woff2";